import React from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const Popup = ({ showPopup, setShowPopup, popupText }) => {
  const navigate = useNavigate();

  const handlePopupClose = () => setShowPopup(false);
  const handlePopupRedirect = () => {
    setShowPopup(false);
    navigate("/pricing");
  };
  return (
    <Modal show={showPopup} onHide={handlePopupClose} centered>
      <Modal.Header>
        <Modal.Title>Insufficient Credits</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {popupText} You will be redirected to the pricing page.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handlePopupClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handlePopupRedirect}>
          Go to Pricing
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Popup;
